import { Component, Input, OnInit } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { DataStoreService } from 'src/app/data-store.service';
import { Player } from 'src/app/models/models';
import { PlayerClassSelectorComponent } from '../player-class-selector/player-class-selector.component';

@Component({
  selector: 'app-player-block',
  templateUrl: './player-block.component.html',
  styleUrls: ['./player-block.component.scss']
})
export class PlayerBlockComponent implements OnInit {



  @Input()
  public player: Player | undefined;

  @Input()
  public showEquipment: boolean = false;

  @Input()
  public showAttributes: boolean = false;

  constructor(public store: DataStoreService, private modalService: BsModalService) { }

  ngOnInit(): void {
  }

  Increment(prop: string) {
    if (this.player) {
      var attribute = <Record<string, number>>this.player.attributes

      if (this.player.freepoints > 0) {
        attribute[prop]++;
        this.player.freepoints--;
        this.store.UpdateStats();
      }


      this.store.Save();
    }
  }

  NextFreepointExp() {
    if (this.player) {
      var total = this.player.freepoints
        + this.player.attributes.attack
        + this.player.attributes.defense
        + this.player.attributes.vitality
        + this.player.attributes.stamina;

      return (total - 3) * 25;// this.SumGeometricSeries(1, 50, 1.4, total - 4);
    }
    return 0;
  }

  HasFreepointExp() {
    return this.player && this.player.exp >= this.NextFreepointExp();
  }
  BuyFreepoint() {
    if (this.player) {
      this.player.exp -= this.NextFreepointExp();
      this.player.freepoints++;
    }
  }



  SumGeometricSeries(numItems: number, priceStart: number, priceRatio: number, currentOwned: number) {
    var actualStart = priceStart * Math.pow(priceRatio, currentOwned);
    return Math.ceil(actualStart * (1 - Math.pow(priceRatio, numItems)) / (1 - priceRatio));
  }

  LevelExpRequirements(p: Player): number {
    var c = this.store.classes.find(x => x.name === p.class);
    if (c != null) {

      return p.level * 50 + 50;// this.SumGeometricSeries(1, 100, 1.1, p.level);
    }
    return 0;
  }

  CanLevelLabel(p: Player) {
    var c = this.store.classes.find(x => x.name === p.class);
    if (c != null) {

      if (this.store.tierBreakpoints[p.level] && p.tier < this.store.tierBreakpoints[p.level]) {
        if (this.HasClassCrystals())
          return 'Use Class Crystal';

        return 'Class Crystal Required';
      }

      return this.LevelExpRequirements(p) + ' EXP';
    }
    return undefined;
  }

  CanLevel(p: Player) {
    var c = this.store.classes.find(x => x.name === p.class);

    if (this.store.tierBreakpoints[p.level] && p.tier < this.store.tierBreakpoints[p.level]) {
      if (this.HasClassCrystals())
        return true;
      return false;
    }

    return p.exp >= this.LevelExpRequirements(p);

  }

  Levelup(p: Player) {

    if (this.store.tierBreakpoints[p.level] && p.tier < this.store.tierBreakpoints[p.level]) {
      if (this.HasClassCrystals())
        this.UseCrystal();
      return;
    }



    p.exp -= ((p.level + 1) * 50)
    p.level++;

    var c = this.store.classes.find(x => x.name === p.class);
    if (c != null) {
      p.attributes.attack += c.levelup.attribute.attack || 0;
      p.attributes.defense += c.levelup.attribute.defense || 0;
      p.attributes.vitality += c.levelup.attribute.vitality || 0;
      p.attributes.stamina += c.levelup.attribute.stamina || 0;
      p.freepoints += c.levelup.attribute_point;
    }
    this.store.UpdateStats();
    this.store.Save();

  }

  HasClassCrystals(): boolean {
    var item = this.store.inventory.find(d => d.name === 'Class Crystal' && d.tier === (this.player?.tier || 0) + 1);
    if (item)
      return item.quantity > 0;

    return false;
  }

  UseCrystal() {
    var item = this.store.inventory.find(d => d.name === 'Class Crystal' && d.tier === (this.player?.tier || 0) + 1);
    if (item) {

      const initialState: ModalOptions = {
        initialState: {
          title: 'Upgrade your Class',
          player: this.player
        }
      };

      var tier = this.player?.tier || 0;
      const bsModalRef = this.modalService.show(PlayerClassSelectorComponent, initialState);
      bsModalRef.onHide?.subscribe(x => {
        if (item && this.player && this.player.tier !== tier) {
          item.quantity -= 1;

          if (item.quantity <= 0) {
            item.quantity = 0;
            item.name = undefined;
            item.tier = 1;
          }

          this.store.Save();
        }
      });

    }
  }

}
